/*
 * @author: Elton Jain
 * Note: 
 * - All variables be declared at top of the parent function
 * - Return the Module object EOF
 * - Reuse UI variables from modules/UI
 * - Seperate code for logic, events, initialization
 * - use '$var' for jQuery objects, and 'var' otherwise
 */
/* global define, require */

define('app',[
    'jquery',
    'UI', // Common DOM UI
    'Auth',
    'Toastr',
    'Config',
    'Tooltip',
    'History',
    'JSTemplate',
    'Helper',
    'cookie',
], function($, UI, Auth, Toastr, Config, Tooltip, History, template, Helper) {
    'use strict';

    // Module variables here
    var App = {},
        CURRENT_ROUTE = null,
        notification,
        langs;

    // Initiate Bugsnag
    if(typeof Bugsnag !== 'undefined') {
        Bugsnag.user = {
            id: Auth.getUser().id,
            name: Auth.getUser().fullname,
            // email: "some@email.com"
        };
    }

    App.init = function() {        
        // console.log('time to app.init: ' + (new Date().getTime() - window.tstart));

        // Initialization
        var base = this;

        Config.init(window._gtap.settings);
        CURRENT_ROUTE = Config.get('page.route');
        langs = Config.get('lang');

        App.setup();

        dirtyBrowserTricks();

        UI.$d.ready(function() {
            base.onDomReady();
        });

        base.bindEvents();

        if(!(Helper.Url.getParam('guid') && Helper.Url.getParam('access_token'))) {
            Auth.init();
        } 

        if($.cookie('loginPopup') == "true" && !Auth.checkLoginRequired({source: 'feed q more answer'})) {
            $.removeCookie('loginPopup');
        }

        require(['Tabber'], function (Tabber) {
            new Tabber();
        });

        require(['Mixpanel', 'Helper'], function(MixPanel, Helper) {            
            Helper.setDevice();
            Config.set('device',window._gtap.settings.device);
            MixPanel.init();
            MixPanel.hit('set_site');

            if(window.campaign && !Auth.check()) {
                if(window._invited_email_) {
                    mixpanel.identify(window._invited_email_);
                } else {
                    mixpanel.identify();
                }
                mixpanel.people.set({
                    'invited_via' : window.campaign
                });

                MixPanel.hit('invite_link_click', {
                    'Campaign': window.campaign
                });
            }

            // Hitting Page Visit Api
            if(CURRENT_ROUTE === 'home' && Auth.check()) {
                MixPanel.hit('visit_page', {
                    'page': 'Home Feed',
                    'type': 'latest'
                });
            } else if(CURRENT_ROUTE === 'home' && !Auth.check()) {
                MixPanel.hit('visit_page', {
                    'page': 'main landing page'
                });
                require(['glide'], function () {
                    $('#reviewGlide').glide({
                        type: "carousel",
                        keyboard: false,autoplay:false
                    });
                });
            } else if(/^(group|group.tv_episode)$/.test(CURRENT_ROUTE)) {
                var groupData = window._gtap.data.pageGroupData;
                // Need Group/Topic name
                if(groupData) {
                    MixPanel.hit('visit_page', {
                        'page': 'Topic Page',
                        'title': groupData.name,
                        'content_id': groupData.id
                    });
                }
            } else if(CURRENT_ROUTE === 'topic' || CURRENT_ROUTE === 'poll') {
                var question = window._gtap.data.questionData || {};
                // Need Group/Topic name
                if(question) {
                    MixPanel.hit('visit_page', {
                        'page': 'Question Page',
                        'content_id': question.topic.id
                    });
                }
            } else if(CURRENT_ROUTE === 'booth.get') {
                MixPanel.hit('visit_page', {
                    'page': 'Photobooth'
                });
            } else if(CURRENT_ROUTE === 'pregnancy.tracker') {
                MixPanel.hit('visit_page', {
                    'page': 'pregnancy tracker'
                });
            } else if(CURRENT_ROUTE === 'baby.tracker') {
                MixPanel.hit('visit_page', {
                    'page': 'baby tracker'
                });
            } else {
                MixPanel.hit('visit_page', {
                    'page': CURRENT_ROUTE
                });
            }
        });

        // Require User Registration only when user is on registration page
        if (/register.step/.test(CURRENT_ROUTE)) {
            require(['modules/UserRegistration'], function(UserRegistration) {});
        } else {
            require(['modules/Search'], function(Search) {});
        }


        if(CURRENT_ROUTE === 'home') {
            require(['PhotoBooth'], function(PhotoBooth) {
                PhotoBooth.init({});
                if(window._gtap.data.boothExists) {
                    PhotoBooth.parseFeed();
                }
            });
        }

        if(/booth/.test(CURRENT_ROUTE)) {
            require(['PhotoBooth', 'Helper'], function(PhotoBooth, Helper) {
                var options = {};
                if(window._gtap.data.boothId) {
                    options.boothId = window._gtap.data.boothId;
                    options.single = true;
                }
                if(Helper.Url.getParam('commentId')) {
                    options.commentId = Helper.Url.getParam('commentId');
                }
                PhotoBooth.init(options);
            });
        }

        if(/hashtag/.test(CURRENT_ROUTE)) {
            require(['PhotoBooth'], function(PhotoBooth) {
                var options = {};
                if(window._gtap.data.hashtag) {
                    options.hashtag = window._gtap.data.hashtag;
                }
                
                PhotoBooth.init(options);
            });
        }

        // Load Feed and Group JS only on pages base need it
        if (/^(home|topic|group|group.tv_episode|unanswered|questionfollow|unhandled.locale|untagged.question|tv|poll)$/.test(CURRENT_ROUTE)) {
            require(['Feed', 'Groups'], function(Feed, Groups) {});
        }

        if(CURRENT_ROUTE === 'home' || CURRENT_ROUTE === 'booth.get' || CURRENT_ROUTE === 'contest.list' || CURRENT_ROUTE === 'tv') {
            UI.$b.on('click','.feed-filter-home-tab', function(ev) {
                var base = $(this),
                    type = base.data('type');

                if(type === 'home') {
                    $.removeCookie('feed_filter');
                } else if(type === 'poll') {
                    $.cookie('feed_filter', 'poll', {expires:2});
                }

                if(type == 'photobooth' || type == 'tv' || type == 'contest') {
                    return true;
                } else {
                    window.location = '/';
                    return false;
                }
                
            });
        }

        if(CURRENT_ROUTE === 'pregnancy.tracker') {
            require(['Tracker'], function(Tracker) {
                Tracker.init({
                    type: 'pregnancy'
                });
            });
        } else if(CURRENT_ROUTE === 'baby.tracker') {
            require(['Tracker'], function(Tracker) {
                Tracker.init({
                    type: 'baby'
                });
            });
        }

        if(CURRENT_ROUTE === 'untagged.question') {
            require(['caret','tags'], function(caret, tags) {
                $('input[name="tags"]').tagEditor();
                UI.$b.on('submit', '.untagged-question-form', function(ev) {
                    var base = $(this),
                        data = base.serialize(),
                        parent = base.closest('.feed-post');
                    $.post('/ajax/question/tag',data, function(response) {
                        parent.fadeOut(300, function() {
                            parent.remove();
                        });
                    });
                    return false;
                });
            });
        }

        /*if (Config.get('page.route') === 'group.photos') {
            require(['FeedAskQuestion', 'Toastr'], function(AskQuestion, Toastr) {

                var showMessage = function(response, form) {
                        var count = parseInt(form.find('.count').html());

                        if ($('.watermark').length > 0 && count > 0) {
                            location.reload();
                        } else {
                            new Toastr({
                                'message': 'Question has been posted'
                            });
                        }
                    };

                new AskQuestion({
                    formPostQuestion: 'frmPostQuestion',
                    txtPostQuestion: 'txtPostQuestion',
                    postAttachments: 'postAttachments',
                    postFileSelect: 'postFileSelect',
                    btnPostAttach: 'btnPostAttach',
                    onPostQuestionCallback: showMessage
                });
            });
        } else */
        if (CURRENT_ROUTE === 'group.notifications') {
            require(['modules/Notification'], function(Notification) {
                var ntf = new Notification();
                ntf.init({
                    elNtfContainerId: 'grpNtfContainer',
                    action: 'getdata',
                    isNtfPage: true,
                    ntfMethod: 'ajax'
                });
            });
        } else if (CURRENT_ROUTE === 'search') { // Removed group invite functionality
            require(['DataList'], function(DataList) {
                var dataList = new DataList(),
                    type = '';

                if (window.location.href.indexOf('type=group') > 0) {
                    type = 'group';
                }

                dataList.init({
                    containerId: 'searchPageContainer',
                    template: 'tplSearchList',
                    useApi: true,
                    autoload: false,
                    useApiAsData: true,
                    api: '/ajax/search',
                    lazyLoad: true,
                    elLazyButtonId: 'loadMoreSearch',
                    apiData: {
                        page: 1,
                        q: $('#searchInputId').val(),
                        type: type
                    },
                    authCheck: true
                });
            });
            
        } else if (/group./.test(CURRENT_ROUTE)) { // Removed user.groups
            require(['Groups'], function(Groups) {});
        } else if (/user./.test(CURRENT_ROUTE)) {
            require(['User'], function(User) {
                User.init();
            });
        } else if(/^(tv|tv.videos|tv.categories|experts)$/.test(Config.get('page.route'))) {
            require(['modules/TV'],function(TV) {
                // TV.init();
            });
        } else if(CURRENT_ROUTE === 'kids.info') {
            require(['KidsInfo'],function(KidsInfo) {
                KidsInfo.init();
            });
        } else if(CURRENT_ROUTE === 'contest.list') {
            require(['glide'], function () {
                $('#contestFeaturedCarousel').glide({
                    type: "carousel",
                    keyboard: false
                });
            });
        } else if(CURRENT_ROUTE === 'contest' || CURRENT_ROUTE === 'blog.interest') {
            require(['Contests'], function(Contests) {
                Contests.init();
            });
        }


        if (Auth.check()) {
              require(['modules/Notification'], function(Notification) {

                notification = new Notification();

                notification.init({
                    elNtfContainerId: 'ntfContainer',
                    action: 'getcount',
                    isNtfPage: false,
                    isBind: true,
                });
            });
        }

        // Removed my groups and group invite input searchify

        if(CURRENT_ROUTE === 'groups.suggestion') {
            require(['Mixpanel'], function(MixPanel) {
                MixPanel.hit('visit_find_groups',{});
            });
        }

        new Tooltip.init();

        if(Config.get('onboardPopup') && !Auth.check()) {
            History.pushState({
                popupId: 'popupOnboard',
                removeEl: false
            });
        }

        setTimeout(function() {
            window.location.reload();
        }, 2000 * 60 * 60);

        require(['Helper'], function(Helper) {
            document.oncopy = Helper.addLinkOnCopy;
        });
    };

    App.bindEvents = function() {
        // Binding actions to DOM
        var $sidebar = UI.$header.find('#navDrawer'),
            $eleNavTrigger = UI.$header.find('#btnNavPageMenu'),
            base = this;

        UI.$b.on('click', '#btnLoginPopup', function () {
            Auth.showLoginPopup();
        });

        UI.$b.on('click', '[data-ismember="false"]', function(ev) {
            ev.preventDefault();
            var groupData,
                base = this;

            require(['Groups'], function(Groups) {
                Groups.showJoinGroupPopup({
                    image: groupData.image,
                    id: groupData.id,
                    name: groupData.name,
                    url: groupData.url
                }, function() {
                    require(['Toastr'], function(Toastr) {
                        new Toastr({
                            'message': 'You joined the group!!'
                        });
                    });
                    $('.btn-join-group').hide();
                    base.removeAttribute('data-ismember');
                });
            });
        });

        // Click on Open in app
        if(Config.get('deviceOS') == 'ios' || Config.get('deviceOS') == 'android') {
            UI.$b.on('click','.close-open-in-app', function(e) {
                var base = $(this),
                    $parent = base.closest('.open-in-app'),
                    inFifteenMinutes = new Date(new Date().getTime() + 15 * 60 * 1000);

                if(Auth.getUser()) {
                    $.cookie('remove_open_in_app',1,{path:'/',expires:inFifteenMinutes});
                }
                
                $parent.fadeOut('slow', function() {
                    $parent.closest('.open-in-app').remove();
                });
            });

            UI.$b.on('click','.open-in-app-text', function(e) {

                var now = new Date().valueOf(),
                    deviceOS = Config.get('deviceOS');

                setTimeout(function () {
                    if (new Date().valueOf() - now > 5000) {
                        return false;
                    }
                    
                    if(deviceOS == 'ios') {
                        window.location = Config.get('IOS_APP_LINK');    
                    }
                    
                }, 2000);

                if(deviceOS == 'android') {
                    window.location = ["intent://", window.location.host, window.location.pathname === '/' ? '' : window.location.pathname,"#Intent;scheme=https;package=", Config.get('PACKAGE_NAME'),";end"].join('');
                } else if(deviceOS == 'ios') {
                    window.location = ["parenttown:/", window.location.pathname].join('');
                }
                
                return false;
            });
        }

        // When user clicks on invite friends button from menu or feed
        UI.$b.on('click', '.invite-friends', function(e) {
            require(['Helper','Mixpanel'], function (Helper,MixPanel) {
                Helper.showInvitePopup({
                    message: langs.invite_popup_text,
                });
                if(UI.$header.is('.open')) {
                    UI.$header.removeClass('open');
                    $eleNavTrigger.removeClass('active');
                }

                MixPanel.hit('user_event', {
                    'event': 'PT Feed User Invite'
                });
            });
            return false;
        });

        // When user clicks to find facebook friends
        UI.$b.on('click','.find-fb-friends',function(e) {
            require(['modules/auth/facebook'], function(FACEBOOK) {
                FACEBOOK.doLogin({
                    type: 'find'
                });
            });

            if(UI.$header.is('.open')) {
                UI.$header.removeClass('open');
                $eleNavTrigger.removeClass('active');
            }
            
            return false;
        });

        // When user clicks on any button related to invite

        UI.$b.on('click', '.invite-container .invite-button', function(e) {
            e.preventDefault();
            var $item = $(this),
                url = $('#inviteURL').val(),
                action = $item.data('action'),
                platform = '',
                type = $(this).closest('#popup-invite-menu').data('type'),
                mxTarget = 'invite_social',
                content=null;

            if(type === 'share') {
                mxTarget = 'share_social';
                content = $(this).closest('#popup-invite-menu').data('content');
            }

            if(action && action.indexOf('invite') >= 0) {
                require(['modules/common/Sharer'], function(Sharer) {
                    var title = '';

                    platform = action.replace('invite_','').trim();
                        
                    if(Auth.getUser().fullname !== '') {
                        title = 'Invitation from ' + Auth.getUser().fullname;
                    } else {
                        title = 'Join your parenting community';
                    }
                    Sharer.share(platform, url, title,'','Hi,%0A You have received an invitation to join Parenttown. Join your friend by clicking link below %0A');    
                });
                
            } else if ($item.data('action') && $item.data('action') === 'copy') {
                Config.set('copy_type', 'invite');
                var successful; // Sometimes, browser does not execute the copy command or might throw an error.
                try {
                    successful = document.execCommand ? document.execCommand('copy') : false;
                } catch(e) {
                    successful = false;
                }

                if(!successful) {
                    window.prompt('Copy the link manually', url);
                }
            }

            require(['Mixpanel'], function(MixPanel) {
                MixPanel.hit(mxTarget, {
                    'type': (platform) ? platform : 'copy',
                    'url' : url,
                    'content': content
                });
            });
            return false;
        });

        require(['modules/common/Sharer'], function(Sharer) {
            $('#btnShare').on('click', function() {
                Sharer.share('facebook', 'http://parenttown.com');
            });
        });

        if(CURRENT_ROUTE === 'user.profile') {                
            $('#userActivityList').on('click', function(ev) {

                if (!Auth.checkLoginRequired({source: 'user activity'})) {
                    return false;
                } else {
                    return true;
                }
                
            });
        }

        $eleNavTrigger.on('click', function() {
            // Closing
            require(['cookie'], function () {
                if(!$.cookie('menu_open')) {
                    if($eleNavTrigger.find('.nav-bubble').length > 0) {
                        $eleNavTrigger.find('.nav-bubble').addClass('hidden');
                        $.cookie('menu_open',true,{
                            path: '/',
                            expires: 30
                        });
                    }
                }
            });
            
            if ($eleNavTrigger.is('.active')) {
                UI.noscroll(false);
                UI.$header.removeClass('open');
            } else {
                UI.noscroll();
                UI.$header.addClass('open');
                require(['Mixpanel'], function(MixPanel) {
                    MixPanel.hit('menu_open',{});
                });

                History.pushState({
                    callback: function() {
                        $eleNavTrigger.removeClass('active');
                        UI.noscroll(false);
                        UI.$header.removeClass('open');
                    }
                });
            }

            $eleNavTrigger.toggleClass('active');
            return false;
        });

        $sidebar.on('click', function(e) {
            if (e.target === this) {
                // $sidebar.removeClass('open');
                History.popState();
                return false;
            }
        });

        // Open / Expand closed forms
        // UI.$b.on('focus change', 'form', function (e) {
        //     e.preventDefault();
        //     $(this).addClass('open');
        // });

        // // UI_FORM
        // UI.$b.on('change', '.fui-dropdown select', function () {
        //     var $select = $(this);
        //     $select.siblings('.text').html($(this).val());
        // });

        UI.$b.on('change', '.ui-switch input[type="radio"]', function() {
            var $radio = $(this);
            $radio.parent('.option').addClass('checked').siblings('.option').removeClass('checked');
        });

        // Baby gender selector
        UI.$b.on('change', '.baby-gender-selector input[type="radio"]', function() {
            var $radio = $(this);
            $radio.parent('.option').addClass('checked').siblings('.option').removeClass('checked');
        });


        // Toggle switch
        UI.$b.on('change', '.ui-form-toggle-switch [type=checkbox]', function() {
            $(this).parent().toggleClass('checked');
        });

        if(CURRENT_ROUTE === 'home' && !Auth.check()) {
           $('a[href*=\\#]').on('click', function(event){     
                event.preventDefault();
                $('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
            });
        }

        if(CURRENT_ROUTE === 'unhandled.locale') {
            UI.$b.on('click','.locale-submit', function(ev) {
                ev.preventDefault();

                var $form = $(this).closest('.locale-form'),
                    countryId = $(this).val(),
                    questionId = $form[0].questionId.value,
                    data = {},
                    $questionEl = $(this).closest('.feed-post');


                if(countryId === '' || questionId === '') {
                    return false;
                }

                data = {
                    countryId: countryId,
                    questionId: questionId
                };

                $.post('/ajax/questionLocale/update', data, function(response) {
                    if(response.status == true) {
                        $questionEl.fadeOut('fast', function() {
                            $questionEl.remove();
                        });

                        require(['Toastr'], function(Toastr) {
                           new Toastr({
                                'message': 'Location Tagged Successfully'
                            });
                        });
                    }
                });

                
                return false;
            });
        }


        /*
         *   Move afterward
         */

        // Sticky Head
        var header_h = UI.$header.outerHeight();

        $('.stick-to-head').each(function() {
            var $ele = $(this);
            $ele.addClass('fixed');
            header_h += $ele.outerHeight();
            UI.$b.css('padding-top', header_h);
        });

        // $('.stick-to-head').each(function () {
        //     var $ele = $(this);
        //     tot_sticky_h += $ele.outerHeight();
        //     $pseudo_wrap.append($ele);
        // });
        // UI.$b.css('padding-top', tot_sticky_h);
        // $pseudo_wrap.css({
        //     'position': 'fixed',
        //     'left': 0,
        //     'right': 0,
        //     'top': header_h,
        //     'z-index': 2
        // }).appendTo(UI.$b);

        // Sticky Ask Question Form
        
        if(Auth.check()) {
            var $formAskWrap = $('#formAskWrap'),
            $formAsk = $formAskWrap.children('form.form-ask');
            stickOnScroll($formAsk, $formAskWrap, header_h);
        } else {
            var $loginBarWrap = $('#appLoginBarWrap:not(.static)'),
            $loginBar = $loginBarWrap.children('.app-login-bar');

            stickOnScroll($loginBar, $loginBarWrap, header_h);

            UI.$b.on('click', '.btn-login-pop', function () {
                Auth.showLoginPopup();
                return false;
            });
        }


        // DropSearch (Input search dropdown)
        // require(['dropsearch'], function(DropSearch) {
        //     new DropSearch({
        //         $select: $('.dropsearch:not(.static)')
        //     });

        //     // Static buckets
        //     new DropSearch({
        //         $select: $('.dropsearch.static'),
        //         staticBucket: true
        //     });
        // });

        // Auto-grow
        require(['autosize'], function(autosize) {
            autosize($('.autogrow'));
        });


        if ($('#gallery').length) {
            // Photo gallery
            require(['modules/common/Gallery'], function(Gallery) {
                new Gallery({
                    eleGallery: '#gallery',
                    eleGalleryData: '#galleryData'
                });
            });
        }

        // Popup close on out
        UI.$b.on('click', '.popup', function(e) {
            if (e.target === this) {
                var $this = $(this),
                    toRemove = $this.data('onclose') === 'remove' ? true : false;

                History.popState(function () {
                    if (toRemove) {
                        $this.remove();
                    }
                });                
                UI.noscroll(false);
            }
        });

        // Take user to particular app store
        if(Config.get('page.route') === 'giveaways' || Config.get('page.route') === 'giveaway-prizes') {
            require(['Helper', 'Mixpanel', 'modules/common/Sharer'], function(Helper, MixPanel, Sharer) {

                UI.$b.on('click','#getBtnApp', function() {

                    UI.$b.addClass('loading');

                    if(Helper.getUserAgent().indexOf("android") > -1 || (Helper.getUserAgent().indexOf("iphone") > -1 || Helper.getUserAgent().indexOf("ipad") > -1)) {
                        MixPanel.hit('click',{
                            campaign: 'giveaway',
                            target: 'Join Contest Button'
                        },function() {
                            if(Helper.getUserAgent().indexOf("android") > -1) {
                                window.location = Config.get('ANDROID_APP_LINK');
                            } else if(Helper.getUserAgent().indexOf("iphone") > -1 || Helper.getUserAgent().indexOf("ipad") > -1) {
                                window.location = Config.get('IOS_APP_LINK');
                            }
                            UI.$b.removeClass('loading');
                        });
                        return false;
                    } else {
                        MixPanel.hit('click',{
                            campaign: 'giveaway',
                            target: 'Join Contest Button'
                        });
                        setTimeout(function() {
                            return true;
                        },500);
                    }
                });

                UI.$b.on('click','#shareContestBtn', function(ev) {
                    Sharer.share('facebook', window.location.origin + $(this).data('url'));
                });
            });
        }
        
        require(['Helper'], function(Helper) {
            UI.$b.on('click', '.btn-share-page', function () {
                Helper.showInvitePopup({
                    type: 'share',
                    url: window.location.href
                });
                return false;
            });
        });


        // Close Popups
        // Close popup page and remove popup from DOM
        UI.$b.on('click', '[class^=popup] .btn-close-remove, [class^=popup] .btn-close', function() {
            History.popState(function () {
                var $btn = $(this);
                if($btn.is('.btn-close-remove')) {
                    $btn.parents('[class^=popup]').remove();
                }
            });
        });

 

        // Close Alerts
        UI.$b.on('click', '.alert .btn-close', function() {
            var $ele = $(this).parents('.alert');
            $ele.slideUp('fast');
            return false;
        });

        // Page Header Back Button
        UI.$header.on('click', '#btnNavPageBack', function () {
            if($(this).is('.gohome')) {
                window.location.href = "/";
            } else {
                if(window.history) {
                    history.back();
                }
            }
        });

        // Show notification page
        UI.$b.on('click', '#btnHeadNtf', function(ev) {
            ev.preventDefault();
            
            var popupId = 'ntfPageContainer',
                $elNtfContainer = $('#' + popupId),
                that = $(this),
                ntfContainerId = 'ntfContainer';

            // Add to history
            History.pushState({
                popupId: popupId,
                isPage: true,
                removeEl: false,
                url: '/user/notifications',
                callback: function (items) {
                    if(items && items.length > 0 && items[items.length - 1].isPage === true) {
                        UI.showBackButton(true);
                    } else {
                        UI.showBackButton(false);
                    }
                    that.removeClass('hidden');
                }
            });

            

            if($('#' + ntfContainerId + ' li').length == 0) {
                notification.getData(false);
            } else if(notification.getUnreadCount() > 0) {
                notification.getData(true);
            }

            notification.updateNotificationBubble(0);
            

            // Display the notification page
            $elNtfContainer.fadeIn('250ms');
            UI.showBackButton();
            that.addClass('hidden');

            UI.noscroll();

            require(['Mixpanel'], function(MixPanel) {
                MixPanel.hit('visit_notification',{});
            });

            return false;
        });

        // Show feedback form
        UI.$b.on('click', '.sendFeedback', function(e) {
            require(['Helper'], function (Helper) {
                Helper.showFeedbackPage(e);
            });
            return false;
        });

        require(['Validation'], function(Validation) {
            UI.$b.on('submit', '#feedbackForm', function(ev) {
                ev.preventDefault();
                var validation = new Validation({
                        form: $(this),
                        allConstraints: {
                            username: {
                                presence: {
                                    message: '^' + langs.err_name
                                }
                            },
                            email: {
                                presence: {
                                    message: '^' + langs.err_email
                                },
                                email: {
                                    message: '^Email is not valid'
                                }
                            },
                            message: {
                                presence: {
                                    message: '^' + langs.err_feedback_msg
                                }
                            }
                        }
                    }),
                    base = this;

                if (validation.isValid() !== true) {
                    return;
                }

                var data;

                if(navigator && navigator.userAgent) {
                    data = $(this).serializeArray().reduce(function(a, x) { a[x.name] = x.value; return a; }, {});
                    data.userAgent = JSON.stringify({
                        BROWSER: navigator.userAgent,
                        CSS_VERSION: Config.get('CSS_VERSION'),
                        JS_VERSION: Config.get('JS_VERSION')
                    }); 
                } else {
                    data = $(this).serialize();
                }
                

                $.ajax({
                    url: '/ajax/feedback/save',
                    data: data,
                    type: 'POST',
                    success: function(result) {
                        UI.noscroll(false);
                        var toastr;

                        if (result.status) {
                            History.popState();
                            base.message.value = base.message.defaultValue;

                            toastr = new Toastr({
                                'message': result.message
                            });


                        } else {
                            toastr = new Toastr({
                                'message': result.message,
                                'class': 'toastr-error',
                                'icon': 'ion-alert'
                            });
                        }
                    }
                });
                return false;
            });
        });


        // Open Login popup
        // require(['Auth'], function(Auth) {
        //     UI.$b.on('click', '.btn-onboard-info', function() {
        //         Auth.showOnboardPopup();
        //     });
        // });

        // require(['cookie', 'Auth'], function(cookie, Auth) {
        //     var $popOnboard = $('#popupOnboard');
        //     $popOnboard.on('click', '.btn-close', function(e) {
        //         e.preventDefault();
        //         $.cookie('onboarded', '1');

        //         require(['Mixpanel'], function(MixPanel) {
        //             MixPanel.hit('carousel_close', {carousel_close: 'close'});
        //         });

        //         // Auth.showOnboardPopup(false);
        //     });
        // });

        // require(['Helper', 'cookie'], function (Helper, Cookie) {
        //     Helper.getGeoLocation(function (position) {
        //         $.cookie('usrLat', position.coords.latitude, {path: '/', expires: 7});
        //         $.cookie('usrLng', position.coords.longitude, {path: '/', expires: 7});
        //     }, function () {
        //         $.cookie('usrLat', false, {path: '/', expires: 7});
        //         $.cookie('usrLng', false, {path: '/', expires: 7});
        //     });
        // });
        
        
        if (Config.get('page.urlParams.s_m')) {
            new Toastr({
                'message': Config.get('toastrMsg')
            });
        }
    };


    App.setup = function() {
        $.ajaxSetup({
            headers: {
                // 'X-CSRF-TOKEN': $('meta[name='csrf-token']').first().attr('content')
                'X-CSRF-TOKEN': $('#metacsrf').first().attr('content')
            }
        });
    };

    App.onDomReady = function() {
        // console.log('time on dom ready: ' + (new Date().getTime() - window.tstart));
        // If sticky foot bar, add padding to it's parent
        var $stickyFoot = $('.sticky-foot');
        if ($stickyFoot.length) {
            UI.$b.css('padding-bottom', $stickyFoot.outerHeight()).css('height', 'auto').css('min-height', '100%');
        }
        // Time Ago
        // new timeago('.timeago');
    };

    App.popUpClose = function(isPage, removeEl, base) {
        var $ele = $(base).parents('[class^=popup]');
        UI.noscroll(false);

        if (isPage && removeEl) {
            $ele.fadeOut('fast', function() {
                $ele.remove();
            });
        } else if ($ele.is('.open')) {
            $ele.removeClass('open');
        } else if (isPage && !removeEl) {
            $ele.fadeOut('fast');
        }
    };

    // Lazy load fonts
    function loadFonts() {
        // If cached, include via server side
        // Else, load and cache
        var fontCookie = 'fontcached',
            fontFile = '/assets/css/fonts.css';

        require(['cookie'], function () {
            if (!$.cookie(fontCookie)) {
                $.ajax({
                    url: fontFile,
                    beforeSend: function ( xhr ) {
                      xhr.overrideMimeType('application/octet-stream');
                    },
                    success: function(data) {
                        $.cookie(fontCookie, true, {
                            expires: 30,
                            path: '/'
                        });

                        $('<link />', {
                        'rel': 'stylesheet',
                        'href': fontFile
                        }).appendTo('head');
                    }
                });
            }
        });

    }

    // Stick the element to header container on scroll
    function stickOnScroll ($ele, $wrapper, extraPadding) {
        if ($wrapper.length) {
            extraPadding = extraPadding || 0;
            
            UI.$w.on('scroll', function() {
                if (UI.$w.scrollTop() > $wrapper.position().top - extraPadding) {
                    $ele.addClass('fixed').css('top', extraPadding);
                } else {
                    $ele.removeClass('fixed');
                }
            });
            
        }
    }


    /*
     * Dirty tricks
     */
    function dirtyBrowserTricks () {
        // Check if Safari
        if (navigator && navigator.userAgent && navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
            $('html').addClass('safari');
        }
    }

    return App;
}); 
